import React from 'react'

import { useMessage } from '../../hooks/message'
import { usePostRequest } from '../../hooks/request'
import { CUSTOMER_LIST } from '../../urls'
import CustomerForm from './CustomerForm'

export default function CustomerCreate({ onCancel, categoryList, expenseReport, brandList }) {
    const products = usePostRequest({ url: CUSTOMER_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success, error } = await products.request({ data })
        if (success) {
            expenseReport.request()
            onCancel()
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>
            <CustomerForm loading={products.loading} categoryList={categoryList} brandList={brandList}
                onCancel={onCancel}
                onSubmit={onSubmit} />
        </div>
    )
}
